import { render, staticRenderFns } from "./IpsativeResponse.vue?vue&type=template&id=9c3090ca&scoped=true&"
import script from "./IpsativeResponse.vue?vue&type=script&lang=js&"
export * from "./IpsativeResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3090ca",
  null
  
)

export default component.exports